
import {Injectable} from '@angular/core';
import {ApiService} from "../../api.service";

@Injectable({
  providedIn: 'root'
})
export class ApiAdminImpactService {

  constructor(private apiService: ApiService) {
  }

  listAll(typeId) {
    return this.apiService.get(`/api/admin/type/${typeId}/impact`);
  }

  get(typeId, id) {
    return this.apiService.get(`/api/admin/type/${typeId}/impact/${id}`);
  }

  delete(typeId, id) {
    return this.apiService.delete(`/api/admin/type/${typeId}/impact/${id}`);
  }

  create(typeId, data) {
    return this.apiService.post(`/api/admin/type/${typeId}/impact`, data);
  }

  update(typeId, id, data) {
    return this.apiService.put(`/api/admin/type/${typeId}/impact/${id}`, data);
  }

  moveUp(typeId, id){
    return this.apiService.patch(`/api/admin/type/${typeId}/impact/${id}/changeorder/up`);
  }

  moveDown(typeId, id){
    return this.apiService.patch(`/api/admin/type/${typeId}/impact/${id}/changeorder/down`);
  }

}



